import type { IconProps } from "../../src/types";
import { splitProps } from "solid-js";

function renderSvg(kebab: string, props: IconProps) {
  const [local, rest] = splitProps(props, ["class", "size", "color", "strokeWidth"]);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={local.size ?? 24}
      height={local.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={local.color ?? "currentColor"}
      stroke-width={local.strokeWidth ?? 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={local.class ? `lucide lucide-${kebab} ${local.class}` : `lucide lucide-${kebab}`}
      aria-hidden={rest["aria-label"] || rest.title ? undefined : "true"}
      {...rest}
    >
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <path d="m14.5 9.5-5 5" />
      <path d="m9.5 9.5 5 5" />
    </svg>
  );
}

export const ShieldClose = (props: IconProps) => renderSvg("shield-close", props);
export const ShieldX = (props: IconProps) => renderSvg("shield-x", props);
export const ShieldCloseIcon = ShieldClose;
export const ShieldXIcon = ShieldX;
export default ShieldClose;
